import React, { memo } from 'react';

interface InputSearchBoxProps {
    inputValue: string;
    placeholder: string;
    onChange: (inputValue: string) => void;
}

const InputSearchBox: React.FC<InputSearchBoxProps> = ({ inputValue, placeholder, onChange }) => {
    console.log('-------------    searchbox re-render   -------------', placeholder, inputValue);
    return (
        <input
            type="text"
            value={inputValue}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            className="light-border p-2 rounded mr-[10px] w-[250px]"
            style={{
                border: "1px solid #ddd"
            }}
        />
    );
};

export default memo(InputSearchBox);